import { baseApi } from "../baseApi";

const calendarApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCalendarToken: builder.query({
      query: () => "/api/calendar/token",
      providesTags: ["CalendarToken"],
    }),
    regenerateCalendarToken: builder.mutation({
      query: () => ({
        url: "/api/calendar/token/regenerate",
        method: "POST",
      }),
      invalidatesTags: ["CalendarToken"],
    }),
  }),
});

export const { useGetCalendarTokenQuery, useRegenerateCalendarTokenMutation } =
  calendarApi;
